// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { Account, AccountRiskStatus, AnnualReview, CashBalance, Command, CommandReport, Contract, ContractGroup, ContractMaturity, Currency, Exchange, ExecutionReport, Fill, FillFee, FillPair, MarginSnapshot, Order, OrderStrategy, OrderStrategyLink, OrderStrategyType, OrderVersion, Position, Product, Property, ShardingExpression, SpreadDefinition, User, UserAccountAutoLiq, UserPlugin, UserPromoCode, UserProperty, UserReadStatus } from '@innolab-trader/tradovate-types'

export interface SyncRequest {
  users?: Array<number>
  accounts?: Array<number>
  splitResponses?: boolean
  cutoffTimestamp?: string
  entityTypes?: Array<string>
  shardingExpression?: ShardingExpression
  fullOrgSnapshot?: boolean
}

export interface SyncMessage {
  users: Array<User>
  accounts?: Array<Account>
  accountRiskStatuses?: Array<AccountRiskStatus>
  marginSnapshots?: Array<MarginSnapshot>
  userAccountAutoLiqs?: Array<UserAccountAutoLiq>
  cashBalances?: Array<CashBalance>
  currencies?: Array<Currency>
  positions?: Array<Position>
  fillPairs?: Array<FillPair>
  orders?: Array<Order>
  contracts?: Array<Contract>
  contractMaturities?: Array<ContractMaturity>
  products?: Array<Product>
  exchanges?: Array<Exchange>
  spreadDefinitions?: Array<SpreadDefinition>
  commands?: Array<Command>
  commandReports?: Array<CommandReport>
  executionReports?: Array<ExecutionReport>
  orderVersions?: Array<OrderVersion>
  fills?: Array<Fill>
  fillFees?: Array<FillFee>
  orderStrategies?: Array<OrderStrategy>
  orderStrategyLinks?: Array<OrderStrategyLink>
  userProperties?: Array<UserProperty>
  properties?: Array<Property>
  userPlugins?: Array<UserPlugin>
  annualReviews?: Array<AnnualReview>
  userReadStatuses?: Array<UserReadStatus>
  userPromoCodes?: Array<UserPromoCode>
  contractGroups: Array<ContractGroup>
  orderStrategyTypes?: Array<OrderStrategyType>
}

/**
 * Validate SyncRequest request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param _request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateSyncRequest(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateSyncRequest(_request: SyncRequest): ValidationError[] {
  const errors: ValidationError[] = []



  return errors
}

export const syncRequest = postEndpoint<SyncRequest, SyncMessage>('/user/syncRequest')
